import request from '@/utils/ajax';

export function deteleAccount(data){
  return request({
    url: `/wx/manage/wxAccount/delete`,
    method: 'post',
    data: data
  });
}

//添加或者更新
export function addAuth(data){
  return request({
    url: `/wx/manage/authorization/save`,
    method: 'post',
    data: data
  });
}

//添加或者更新
export function editAuth(data){
  return request({
    url: `/wx/manage/authorization/update`,
    method: 'put',
    data: data
  });
}
